/**
 * Role Interface
 * User management - Role model
 */

import type { UserRole } from './supervisor-split-assign.interface';

export interface Role {
  id: number;
  role_id: number;
  value: string; // Role name
  role_name?: string;
  role_short_name: string;
  parent_role_id: number | null;
  parent_role?: string;
  role_level: number;
  conversion_value: number; // Points conversion value
  cash_conversion_value: number;
  points_conversion_value?: number;
  terms?: string;
  end_user: number; // 0 or 1
  status?: number;
  created_at?: string;
  updated_at?: string;
}

export interface RoleFormData {
  parent_role_id: number | null;
  role_name: string;
  role_short_name: string;
  points_conversion_value: number;
  cash_conversion_value: number;
  terms?: string;
  end_user: boolean | number;
}

export interface RoleFieldData {
  table_fields_id: number | null;
  value: any;
  field_short_name: string;
}

export interface RoleCreatePayload {
  field_data: RoleFieldData[];
  role_id?: string | number;
  verify_bank: number;
  verify_id: number;
  end_user: number;
}

// New simplified payload for create-user-role API (program roles only)
export interface RoleCreateUserPayload {
  role_name: string; // Full role name
  short_name: string; // Short name
  parent_role_id: number;
  role_type: number; // 1 = System, 2 = Program Field, 3 = Program
  program_id?: number;
}

// Simplified payload for update-role API
export interface RoleUpdateUserPayload {
  id: number;
  role_name: string;
  short_name: string;
  parent_role_id: number;
  role_type: number;
}

export interface RoleApiResponse {
  success: boolean;
  status: number;
  data: UserRole[] | Role[] | string;
  message?: string;
}

export interface DynamicField {
  id: number;
  field_name: string;
  field_short_name: string;
  field_type_id?: number;
  input_type_id?: number;
  // Add other fields as needed
}

export interface DynamicFieldResponse {
  data: {
    GNRL?: DynamicField[];
    [key: string]: any;
  };
}
